import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

export const Drug = props => (
  <SvgIcon {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Drug" fill="currentcolor" fillRule="nonzero">
        <g id="baseline-spellcheck-24px">
          <path
            d="M21.21,23.47H2.48a1.13,1.13,0,0,1-1.14-1.13V3.61a1.14,1.14,0,1,1,2.27,0V21.12c2.52-.5,3.34-3,4.24-6.64.74-3,1.57-6.38,4.8-6.38,3.43,0,4.22,3.73,4.92,7,.81,3.79,1.46,6.09,3.64,6.09a1.13,1.13,0,0,1,0,2.26ZM7.55,21.21h9.66a17.7,17.7,0,0,1-1.85-5.62c-.69-3.25-1.22-5.22-2.71-5.22-1.31,0-1.82,1.49-2.61,4.65C9.54,17,8.94,19.47,7.55,21.21Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export default Drug



// WEBPACK FOOTER //
// ./src/icons/Probability.js